/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/evaluateContextInstanceOverrides';
import type { EvaluateContextInstanceQueryParams } from '../../operation-overrides/evaluateContextInstanceOverrides';

export type EvaluateContextInstancePathParams = NonNullable<
  operations['evaluateContextInstance']['parameters']['path']
>;
export type { EvaluateContextInstanceQueryParams };

export type EvaluateContextInstanceRequestBody = OperationRequestBodyContent<operations['evaluateContextInstance']>;

export interface Input extends EvaluateContextInstancePathParams {
  apiVersion?: string;
  query?: EvaluateContextInstanceQueryParams;
  body: EvaluateContextInstanceRequestBody;
}

export async function evaluateContextInstance(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/flags/evaluate', {
    params: {
      path,
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
